import psychologyUnit1Notes from "./psychology/unit-1";
import psychologyUnit2Notes from "./psychology/unit-2";
import psychologyUnit3Notes from "./psychology/unit-3";
import psychologyUnit4Notes from "./psychology/unit-4";
import psychologyUnit5Notes from "./psychology/unit-5";
import statisticsUnit1 from "./statistics/unit-1";
import statisticsUnit2 from "./statistics/unit-2";
import statisticsUnit3 from "./statistics/unit-3";
import statisticsUnit4 from "./statistics/unit-4";
import statisticsUnit5 from "./statistics/unit-5";
import statisticsUnit6 from "./statistics/unit-6";
import statisticsUnit7 from "./statistics/unit-7";
import statisticsUnit8 from "./statistics/unit-8";
import statisticsUnit9 from "./statistics/unit-9";
import type { SubjectNotes, UnitNotes } from "./types";

// Import world history units
import worldHistoryUnit1 from "./world-history/unit-1";
import worldHistoryUnit2 from "./world-history/unit-2";
import worldHistoryUnit3 from "./world-history/unit-3";
import worldHistoryUnit4 from "./world-history/unit-4";
import worldHistoryUnit5 from "./world-history/unit-5";
import worldHistoryUnit6 from "./world-history/unit-6";
import worldHistoryUnit7 from "./world-history/unit-7";
import worldHistoryUnit8 from "./world-history/unit-8";
import worldHistoryUnit9 from "./world-history/unit-9";
import governmentUnit1 from "./government/unit-1";
import governmentUnit2 from "./government/unit-2";
import governmentUnit3 from "./government/unit-3";
import governmentUnit4 from "./government/unit-4";
import governmentUnit5 from "./government/unit-5";
import humanGeographyUnit1 from "./human-geography/unit-1";
import humanGeographyUnit2 from "./human-geography/unit-2";
import humanGeographyUnit3 from "./human-geography/unit-3";
import humanGeographyUnit4 from "./human-geography/unit-4";
import humanGeographyUnit5 from "./human-geography/unit-5";
import humanGeographyUnit6 from "./human-geography/unit-6";
import humanGeographyUnit7 from "./human-geography/unit-7";
import calculusAbUnit1 from "./calculus-ab/unit-1";
import calculusAbUnit2 from "./calculus-ab/unit-2";
import calculusAbUnit3 from "./calculus-ab/unit-3";
import calculusAbUnit4 from "./calculus-ab/unit-4";
import calculusAbUnit5 from "./calculus-ab/unit-5";
import calculusAbUnit6 from "./calculus-ab/unit-6";
import calculusAbUnit7 from "./calculus-ab/unit-7";
import calculusAbUnit8 from "./calculus-ab/unit-8";
import calculusBcUnit1 from "./calculus-bc/unit-1";
import calculusBcUnit2 from "./calculus-bc/unit-2";
import calculusBcUnit3 from "./calculus-bc/unit-3";
import calculusBcUnit4 from "./calculus-bc/unit-4";
import calculusBcUnit5 from "./calculus-bc/unit-5";
import calculusBcUnit6 from "./calculus-bc/unit-6";
import calculusBcUnit7 from "./calculus-bc/unit-7";
import calculusBcUnit8 from "./calculus-bc/unit-8";
import calculusBcUnit9 from "./calculus-bc/unit-9";
import calculusBcUnit10 from "./calculus-bc/unit-10";
import precalculusUnit1 from "./precalculus/unit-1";
import precalculusUnit2 from "./precalculus/unit-2";
import precalculusUnit3 from "./precalculus/unit-3";
import precalculusUnit4 from "./precalculus/unit-4";
import biologyUnit1 from "./biology/unit-1";
import biologyUnit2 from "./biology/unit-2";
import biologyUnit3 from "./biology/unit-3";
import biologyUnit4 from "./biology/unit-4";
import biologyUnit5 from "./biology/unit-5";
import biologyUnit6 from "./biology/unit-6";
import biologyUnit7 from "./biology/unit-7";
import biologyUnit8 from "./biology/unit-8";
import microeconomicsUnit1 from "./microeconomics/unit-1";
import microeconomicsUnit2 from "./microeconomics/unit-2";
import microeconomicsUnit3 from "./microeconomics/unit-3";
import microeconomicsUnit4 from "./microeconomics/unit-4";
import microeconomicsUnit5 from "./microeconomics/unit-5";
import microeconomicsUnit6 from "./microeconomics/unit-6";
import computerScienceUnit1 from "./computer-science-principles/unit-1";
import computerScienceUnit2 from "./computer-science-principles/unit-2";
import computerScienceUnit3 from "./computer-science-principles/unit-3";
import computerScienceUnit4 from "./computer-science-principles/unit-4";
import computerScienceUnit5 from "./computer-science-principles/unit-5";
import compSciUnit1Notes from "./computer-science-a/unit-1";
import compSciUnit2Notes from "./computer-science-a/unit-2";
import compSciUnit3Notes from "./computer-science-a/unit-3";
import compSciUnit4Notes from "./computer-science-a/unit-4";
import physicsUnit1Notes from "./physics-1/unit-1";
import physicsUnit2Notes from "./physics-1/unit-2";
import physicsUnit3Notes from "./physics-1/unit-3";
import physicsUnit4Notes from "./physics-1/unit-4";
import physicsUnit5Notes from "./physics-1/unit-5";
import physicsUnit6Notes from "./physics-1/unit-6";
import physicsUnit7Notes from "./physics-1/unit-7";
import physicsUnit8Notes from "./physics-1/unit-8";



// Store all subject notes
const ALL_NOTES: SubjectNotes[] = [
  {
    subjectSlug: "psychology",
    units: [psychologyUnit1Notes, psychologyUnit2Notes, psychologyUnit3Notes, psychologyUnit4Notes, psychologyUnit5Notes]
  },
  {
    subjectSlug: "world-history",
    units: [worldHistoryUnit1, worldHistoryUnit2, worldHistoryUnit3, worldHistoryUnit4, worldHistoryUnit5, worldHistoryUnit6, worldHistoryUnit7, worldHistoryUnit8, worldHistoryUnit9]
  },
  {
    subjectSlug: "comparative-government-and-politics",
    units: [governmentUnit1, governmentUnit2, governmentUnit3, governmentUnit4, governmentUnit5]
  },
  {
    subjectSlug: "biology",
    units: [biologyUnit1, biologyUnit2, biologyUnit3, biologyUnit4, biologyUnit5, biologyUnit6, biologyUnit7, biologyUnit8]
  },
  {
    subjectSlug: "human-geography",
    units: [humanGeographyUnit1, humanGeographyUnit2, humanGeographyUnit3, humanGeographyUnit4, humanGeographyUnit5, humanGeographyUnit6, humanGeographyUnit7]
  },
  {
    subjectSlug: "calculus-ab",
    units: [calculusAbUnit1, calculusAbUnit2, calculusAbUnit3, calculusAbUnit4, calculusAbUnit5, calculusAbUnit6, calculusAbUnit7, calculusAbUnit8]
  },
  {
    subjectSlug: "calculus-bc",
    units: [calculusBcUnit1, calculusBcUnit2, calculusBcUnit3, calculusBcUnit4, calculusBcUnit5, calculusBcUnit6, calculusBcUnit7, calculusBcUnit8, calculusBcUnit9, calculusBcUnit10]
  },
  {
    subjectSlug: "statistics",
    units: [statisticsUnit1, statisticsUnit2, statisticsUnit3, statisticsUnit4, statisticsUnit5, statisticsUnit6, statisticsUnit7, statisticsUnit8, statisticsUnit9]
  },
  {
    subjectSlug: "microeconomics",
    units: [microeconomicsUnit1, microeconomicsUnit2, microeconomicsUnit3, microeconomicsUnit4, microeconomicsUnit5, microeconomicsUnit6]
  },
  {
    subjectSlug: "computer-science-principles",
    units: [computerScienceUnit1,computerScienceUnit2,computerScienceUnit3,computerScienceUnit4, computerScienceUnit5]
  },
  {
    subjectSlug: "computer-science-a",
    units: [compSciUnit1Notes, compSciUnit2Notes, compSciUnit3Notes, compSciUnit4Notes]
  },
  {
    subjectSlug: "physics-1",
    units: [physicsUnit1Notes, physicsUnit2Notes, physicsUnit3Notes, physicsUnit4Notes, physicsUnit5Notes, physicsUnit6Notes, physicsUnit7Notes, physicsUnit8Notes]
  },
  {
    subjectSlug: "precalculus",
    units: [precalculusUnit1, precalculusUnit2, precalculusUnit3, precalculusUnit4]
  }
  
];

// Helper function to get notes for a specific unit by unit index number
export function getUnitNotesByIndex(subjectSlug: string, unitIndex: number): UnitNotes | null {
  const subjectNotes = ALL_NOTES.find(s => s.subjectSlug === subjectSlug);
  if (!subjectNotes) return null;
  
  // Match by unit number - our notes use "unit-1", "unit-2" format
  const notes = subjectNotes.units.find(u => {
    const notesUnitMatch = u.unitId.match(/unit-(\d+)/i);
    if (notesUnitMatch && parseInt(notesUnitMatch[1], 10) === unitIndex) {
      return true;
    }
    return false;
  });
  
  return notes || null;
}

// Helper function to get notes for a specific unit (by ID string - legacy)
export function getUnitNotes(subjectSlug: string, unitId: string): UnitNotes | null {
  const subjectNotes = ALL_NOTES.find(s => s.subjectSlug === subjectSlug);
  if (!subjectNotes) return null;
  
  // Try to find by exact unitId match or by unit number pattern
  const notes = subjectNotes.units.find(u => {
    // Match by unit-id format
    if (u.unitId === unitId) return true;
    
    // Database format: {subject-slug}-unit-{number} (e.g., "psychology-unit-1")
    // Match against this format
    const dbUnitMatch = unitId.match(new RegExp(`^${subjectSlug}-unit-(\\d+)$`, 'i'));
    if (dbUnitMatch) {
      const unitNum = dbUnitMatch[1];
      // Our notes use "unit-1" format
      if (u.unitId === `unit-${unitNum}`) return true;
    }
    
    // Match by checking if unitId contains "1" for unit 1, etc.
    const unitMatch = unitId.match(/unit[_-]?(\d+)/i);
    const notesUnitMatch = u.unitId.match(/unit[_-]?(\d+)/i);
    if (unitMatch && notesUnitMatch && unitMatch[1] === notesUnitMatch[1]) return true;
    
    // Match by checking if the unitId ends with a unit number
    const unitNumFromId = unitId.match(/(\d+)$/);
    const unitNumFromNotes = u.unitId.match(/(\d+)$/);
    if (unitNumFromId && unitNumFromNotes && unitNumFromId[1] === unitNumFromNotes[1]) return true;
    
    return false;
  });
  
  return notes || null;
}

// Get all available notes for a subject
export function getSubjectNotesContent(subjectSlug: string): UnitNotes[] {
  const subjectNotes = ALL_NOTES.find(s => s.subjectSlug === subjectSlug);
  return subjectNotes?.units || [];
}

// Check if notes exist for a unit
export function hasUnitNotes(subjectSlug: string, unitId: string): boolean {
  return getUnitNotes(subjectSlug, unitId) !== null;
}
